export default __webpack_public_path__ + "static/media/checkbox-fill.94cff0d6.svg";